import { render, staticRenderFns } from "./NCLDC2022.vue?vue&type=template&id=4db08b86&scoped=true"
import script from "./NCLDC2022.vue?vue&type=script&lang=js"
export * from "./NCLDC2022.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db08b86",
  null
  
)

export default component.exports